module.exports = __webpack_public_path__ + "img/carshina21_13.c823aa63.jpg";